import {LogLevel} from '@azure/msal-browser';
import {REGISTER_ENTRA_ID_PAGE} from './const/routes';
import configuration from "./configuration";
export const msalConfig = {
    auth: {
        clientId:  configuration?.msalClientId,
        authority: configuration?.msalAuthority,
        redirectUri: '/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (
                level: LogLevel,
                message: string,
                containsPii: boolean,
            ) => {
                // if (containsPii) {
                //     return;
                // }
                // switch (level) {
                //     case LogLevel.Error:
                //         console.error(message);
                //         return;
                //     case LogLevel.Info:
                //         console.info(message);
                //         return;
                //     case LogLevel.Verbose:
                //         console.debug(message);
                //         return;
                //     case LogLevel.Warning:
                //         console.warn(message);
                //         return;
                //     default:
                //         return;
                // }
            },
        },
    },
};

export const protectedResources = {
    toDoListAPI: {
        scopes: {
            read: ['api://d62149a1-1f6e-48f2-92e9-44f688d2a4de/ToDoList.Read'],
            write: [
                'api://d62149a1-1f6e-48f2-92e9-44f688d2a4de/ToDoList.ReadWrite',
            ],
        },
    },
};

export const loginRequest = {
    scopes: [
        ...protectedResources.toDoListAPI.scopes.read,
        ...protectedResources.toDoListAPI.scopes.write,
    ],
};
